/* eslint-disable */
import NewTeamMembers from './container';
export default NewTeamMembers;



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/NewTeamMembers/index.js